/* eslint-disable import/no-anonymous-default-export */
import {
    SET_USER_PROFILE,
    SET_USER_PROFILE_LOADING,
    SET_USER_VOUCHERS,
    SET_USER_VOUCHERS_LOADING,
    SET_USER_PURCHASES,
    SET_USER_PURCHASES_LOADING,
    PROFILE_ERROR,
} from "actions/types";

const initialState = {
    profile: null,
    vouchers: [],
    purchases: [],
    profileLoading: false,
    vouchersLoading: false,
    purchasesLoading: false,
    error: null,
};

export default function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_USER_PROFILE_LOADING:
            return {
                ...state,
                profileLoading: payload,
                error: null,
            };
        case SET_USER_PROFILE:
            return {
                ...state,
                profile: payload,
                profileLoading: false,
                error: null,
            };
        case SET_USER_VOUCHERS_LOADING:
            return {
                ...state,
                vouchersLoading: payload,
                error: null,
            };
        case SET_USER_VOUCHERS:
            return {
                ...state,
                vouchers: payload,
                vouchersLoading: false,
                error: null,
            };
        case SET_USER_PURCHASES_LOADING:
            return {
                ...state,
                purchasesLoading: payload,
                error: null,
            };
        case SET_USER_PURCHASES:
            return {
                ...state,
                purchases: payload,
                purchasesLoading: false,
                error: null,
            };
        case PROFILE_ERROR:
            return {
                ...state,
                profileLoading: false,
                vouchersLoading: false,
                purchasesLoading: false,
                error: payload,
            };
        default:
            return state;
    }
}
